import { graphql } from 'gql';
import { PromoSubscriptionEdge } from 'gql/graphql';

export const promoGenresQuery = `
  query promoGenresQuery {
    viewer {
      id
      promoPool {
        genres {
          id
          name
          slug
        }
      }
    }
  }
 `;

export const PromoPoolLabels = graphql(`
  query PromoLabelInvites(
    $page: Int
    $perPage: Int
    $filterBy: PromoSubscriptionFilterInput
    $orderBy: PromoSubscriptionOrderInput
    $status: LabelSubscriptionEnum
  ) {
    viewer {
      id
      promoPool {
        labels(
          page: $page
          perPage: $perPage
          filterBy: $filterBy
          orderBy: $orderBy
          status: $status
        ) {
          pageInfo {
            pageCount
            nodeCount
            hasNextPage
            hasPreviousPage
            __typename
          }
          edges {
            __typename
            id
            addedAt
            hasArchiveAccess
            state
            node {
              id
              name
              slug
              logo(size: THUMB) {
                url
              }
              topArtists {
                id
                name
              }
              genres {
                id
                name
              }
              beatportFollowerCount
              soundcloudFollowerCount
              __typename
            }
          }
        }
      }
    }
  }
`);

export const promoPoolSingleLabelQuery = `
  query promoPoolSingleLabelQuery($filterBy: PromoSubscriptionFilterInput) {
    viewer {
      id
      promoPool {
        labels(filterBy: $filterBy) {
          edges {
            __typename
            id
            state
            node {
              id
              name
              slug
              logo(size: THUMB) {
                url
              }
              genres {
                id
                name
              }
              beatportFollowerCount
              soundcloudFollowerCount
              __typename
            }
          }
        }
      }
    }
  }
 `;

export interface PromoPoolSingleLabel {
  viewer: {
    id: string;
    promoPool: {
      labels: {
        edges: Pick<PromoSubscriptionEdge, 'id' | 'state' | 'node'>[];
      };
    };
  };
}

export const followMutation = `
   mutation followLabel($labelId: ID!) {
     followLabelSubscription(input: { labelId: $labelId }) {
       label {
         id
       }
       errors
     }
   }
 `;

export const dismissMutation = `
   mutation dismissLabel($labelId: ID!) {
     dismissLabelSubscription(input: { labelId: $labelId }) {
       label {
         id
       }
       errors
     }
   }
 `;
